export const AlertVariant = {
  default: 'default',
  blue: 'blue',
  green: 'green',
  red: 'red',
  yellow: 'yellow',
} as const
